export const imgApi = `https://imgstore.bangles.org.in`;

// export const localApi = `http://localhost:8089/api`;
// export const localApib2b = `http://localhost:8089/api`;
// export const localApi = `https://bangles.org.in:8443/testing`;
// export const localApi = `https://inshabangles.com:8443/api`;
// export const localApi = `https://bangles.org.in:8443/api`;
// export const localApi = `https://api.inshabangles.com/inshaApp`;
// export const localApi = `https://api.inshabangles.com/indianb2b`;
// export const localApib2b = `https://api.inshabangles.com/indianb2b`;
export const localApi = `https://api.indianbangles.in/b2bPlatform`;
export const localApib2b = `https://api.indianbangles.in/b2bPlatform`;
export const inshaApi = `https://api.indianbangles.in/orgOriginal`;
export const localApiImage = `https://indianbangles.in/imgstore`;

// temporary use for Razorpay
export const localInshaApi = `https://api.inshabangles.com/inshab2b`;

export const username = "admin";
export const password = "Insha_!@#$21Bangles";

export const credentials = btoa(`${username}:${password}`);

export const adminObj = JSON.parse(sessionStorage.getItem("sessionData"));

export const catApi = async () => {
  const api = localApi + `/category/list/byAdminId/${adminObj.id}`;
  const result = await fetch(api, {
    method: "GET",
    headers: {
      Authorization: `Basic ${credentials}`,
    },
  });
  const getResult = await result.json();
  return getResult;
};

export const roundUp = (num, decimals) => {
  const factor = Math.pow(10, decimals);
  return Math.ceil(num * factor) / factor;
};

export const parseLastDays = (text) => {
    if (!text) return Infinity;

    const lower = text.toLowerCase();

    if (lower.includes("minute")) {
        return parseInt(lower.replace(/[^0-9]/g, "")) || 0; // minutes
    } else if (lower.includes("hour")) {
        return (parseInt(lower.replace(/[^0-9]/g, "")) || 0) * 60;
    } else if (lower.includes("day")) {
        return (parseInt(lower.replace(/[^0-9]/g, "")) || 0) * 1440; // 1 day = 1440 min
    }
    return Infinity;
};
